import DGTable from './dg-table'

DGTable.install = (Vue) => {
  Vue.component(DGTable.name, DGTable)
}
export default DGTable
